// import '../Scss/Frontend/Navigation/OffCanvas.scss';

import $ from 'jquery';

$('[data-toggle="offcanvas"]').on('click', function () {
	$('.offcanvas-collapse').add(this).toggleClass('open');
	$('body').toggleClass('offcanvas-open')
});
$('.offcanvas-collapse .nav-item.sub > a').on('click', e => e.preventDefault());
$('.offcanvas-collapse .subnav').on('show.bs.collapse hide.bs.collapse', function() {
	$(this).closest('.dropdown').toggleClass('show');
})

